import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { Box, Spinner } from "grommet";

const ManagerRoute = () => {
  const { user, authLoading } = useContext(AuthContext);

  if (authLoading) {
    return (
      <Box fill align="center" justify="center">
        <Spinner size="large" />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  const hasManagerAccess = user.role === "manager" || user.user_table_id !== undefined;

  if (!hasManagerAccess) {
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default ManagerRoute;
